<div class="grid grid-nogutter app-page" data-cy="page-container">
  <div class="col-10 col-offset-1">
    <div>
      <app-spinner *ngIf="isLoading"></app-spinner>
      <div *ngIf="isLoading !== true && error">
        <app-page-error [error]="error"></app-page-error>
      </div>
      <div *ngIf="isLoading !== true && !error">
        <div *ngIf="title" class="flex align-items-center mb-5" [ngClass]="{ 'justify-content-center': centerTitle }">
          <h1 class="m-0 inline-block text-primary-blue-700" data-cy="page-title">{{ title }}</h1>
          <div class="inline-block">
            <ng-content select="[slot=title]"></ng-content>
          </div>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
